import { useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { useFetch } from 'hooks/util/useFetch';
import { AuthLoginRequest } from 'models/api/auth';
import { ApiError } from 'models/api/error';
import { User } from 'models/api/user';

export const useAuthLogin = () => {
  const [$fetch] = useFetch<User>();
  const queryClient = useQueryClient();
  return useMutation<User, ApiError, AuthLoginRequest>(
    (values) =>
      $fetch('/api/auth/login', {
        body: values,
        method: 'POST',
      }),
    {
      onError: (error) => {
        toast.error(error.data.message || 'An unexpected error occurred');
      },
      onSuccess: (data) => {
        toast.success(`Welcome back, ${data.firstName}!`);
        queryClient.setQueryData(['auth'], data);
      },
    },
  );
};
